export function staffMessageState(message) {
  if (String(message?.direction || '').toLowerCase() === 'inbound') {
    return { key: 'received', label: 'Received' };
  }
  const status = String(message?.delivery_status || '').toLowerCase();
  if (status === 'read') return { key: 'read', label: 'Read' };
  if (status === 'delivered') return { key: 'delivered', label: 'Delivered' };
  if (status === 'failed') return { key: 'failed', label: 'Failed' };
  if (status === 'sent') return { key: 'sent', label: 'Sent' };
  if (status === 'provider_accepted') return { key: 'accepted', label: 'Accepted' };
  if (message?.provider_message_id) return { key: 'sent', label: 'Sent' };
  return { key: 'recorded', label: 'Recorded' };
}

export function staffMessageChannel(message) {
  return String(message?.channel || 'email').toLowerCase() === 'whatsapp' ? 'WhatsApp' : 'Email';
}

export function staffMessageDirectionLabel(message) {
  const inbound = String(message?.direction || '').toLowerCase() === 'inbound';
  const channel = staffMessageChannel(message);
  return inbound ? `Inbound ${channel}` : `Outbound ${channel}`;
}

export function summarizeStaffCommunications(payload) {
  const messages = Array.isArray(payload?.messages) ? payload.messages : [];
  return {
    messages,
    employee: payload?.employee || null,
    thread: payload?.thread || null,
    emailEnabled: payload?.capabilities?.email?.enabled === true,
    emailReason: payload?.capabilities?.email?.reason || null,
    whatsappEnabled: payload?.capabilities?.whatsapp?.enabled === true,
    whatsappReason: payload?.capabilities?.whatsapp?.reason || null,
    readOnly: payload?.capabilities?.read_only === true,
    readOnlyReason: payload?.capabilities?.read_only_reason || null,
  };
}

export function summarizeStaffWhatsAppStatus(payload) {
  const options = Array.isArray(payload?.templates?.template_options)
    ? payload.templates.template_options.filter((item) => item?.key && item?.label)
    : [];
  const configuredKeys = Array.isArray(payload?.templates?.configured_template_keys)
    ? payload.templates.configured_template_keys
    : [];
  return {
    ready: payload?.ready === true,
    domain: payload?.domain || 'staff',
    sendMode: payload?.send_mode || 'approved_staff_templates_only',
    options,
    configuredKeys,
    invalidTemplateKeys: payload?.templates?.invalid_template_keys || {},
    providerReasons: Array.isArray(payload?.provider?.reasons) ? payload.provider.reasons : [],
  };
}

export function summarizeStaffCommunicationsHub(payload) {
  const rows = Array.isArray(payload?.rows)
    ? payload.rows.filter((row) => row?.employee_id && row?.display_name)
    : [];
  return {
    rows,
    summary: payload?.summary || {
      total_staff: rows.length,
      active: 0,
      onboarding: 0,
      inactive: 0,
      unread_conversations: 0,
      total_unread: 0,
    },
    channel: payload?.channel || 'multi',
    whatsappEnabled: payload?.whatsapp?.enabled === true,
    whatsappReason: payload?.whatsapp?.reason || null,
  };
}

export function filterStaffCommunicationsHubRows(
  rows,
  { query = '', status = 'current', unreadOnly = false, channel = 'all' } = {},
) {
  const normalizedQuery = String(query || '').trim().toLowerCase();
  const normalizedStatus = String(status || 'current').toLowerCase();
  const normalizedChannel = String(channel || 'all').toLowerCase();

  return (Array.isArray(rows) ? rows : []).filter((row) => {
    const rowStatus = String(row?.status || '').toLowerCase();
    const rowChannel = String(row?.channel || 'email').toLowerCase();
    const channels = Array.isArray(row?.channels)
      ? row.channels.map((value) => String(value || '').toLowerCase())
      : [rowChannel];

    if (normalizedStatus === 'current' && !['active', 'onboarding'].includes(rowStatus)) return false;
    if (['active', 'onboarding', 'inactive'].includes(normalizedStatus) && rowStatus !== normalizedStatus) return false;
    if (unreadOnly && Number(row?.unread_count || 0) <= 0) return false;
    if (normalizedChannel !== 'all' && !channels.includes(normalizedChannel)) return false;

    if (normalizedQuery) {
      const haystack = [
        row?.display_name,
        row?.employee_code,
        row?.contact_email,
        row?.subject,
        row?.last_preview,
      ].join(' ').toLowerCase();
      if (!haystack.includes(normalizedQuery)) return false;
    }

    return true;
  });
}
